export default __webpack_public_path__ + "static/media/NoResults.bd95337f.svg";